var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterestAcceptActivityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "#FFEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1826 24.7236C35.1362 24.7236 34.1938 25.1457 33.5001 25.8279C32.8121 25.1457 31.864 24.7236 30.8176 24.7236C28.7132 24.7236 27.002 26.4291 27.002 28.5393C27.002 28.7011 27.0135 28.863 27.0366 29.0249C27.2737 32.5341 33.6273 35.8641 33.5001 35.8294C33.3729 35.8583 39.7265 32.5283 39.9635 29.0191C39.9809 28.8572 39.9982 28.7011 39.9982 28.5335C39.9982 26.4349 38.287 24.7236 36.1826 24.7236Z",
    fill: "#E60000",
    fillOpacity: 0.81
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1289 38.7144H25.7998C26.1178 38.7144 26.378 38.4542 26.378 38.1362C26.378 37.8183 26.1178 37.5581 25.7998 37.5581H23.1289C22.8109 37.5581 22.5508 37.8183 22.5508 38.1362C22.5508 38.4542 22.8109 38.7144 23.1289 38.7144Z",
    fill: "#F1C9C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2676 38.1362C28.2676 38.4542 28.5277 38.7144 28.8457 38.7144H43.877C44.1949 38.7144 44.4551 38.4542 44.4551 38.1362C44.4551 37.8183 44.1949 37.5581 43.877 37.5581H28.8457C28.522 37.5581 28.2676 37.8125 28.2676 38.1362Z",
    fill: "#F1C9C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1289 41.1135H43.872C44.19 41.1135 44.4502 40.8534 44.4502 40.5354C44.4502 40.2174 44.19 39.9573 43.872 39.9573H23.1289C22.8109 39.9573 22.5508 40.2174 22.5508 40.5354C22.5508 40.8534 22.8109 41.1135 23.1289 41.1135Z",
    fill: "#F1C9C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6528 45.8368C50.6298 45.8368 51.4219 45.0448 51.4219 44.0677V21.3705C51.4219 20.3877 50.6298 19.5957 49.6528 19.5957H17.3472C16.3702 19.5957 15.5781 20.3877 15.5781 21.3705V44.0677C15.5781 45.0448 16.3702 45.8368 17.3472 45.8368H37.2173V43.1427H21.0761C21.0761 41.5934 19.8216 40.3388 18.2722 40.3388V25.0937C19.8216 25.0937 21.0761 23.8391 21.0761 22.2898H45.9239C45.9239 23.8391 47.1784 25.0937 48.7278 25.0937V40.3388C47.5831 40.3388 46.6061 41.0268 46.1667 42.0038L49.1267 43.0791V45.831H49.6528V45.8368Z",
    fill: "url(#paint0_linear_6779_1492)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1716 53.4045L46.3455 51.4447C47.3572 50.8203 47.9758 49.7161 47.9758 48.5252V43.8944L43.1773 42.1484L38.3789 43.8944V48.5252C38.3789 49.7161 38.9975 50.8203 40.0034 51.4447L43.1716 53.4045ZM40.4139 47.1839C40.6741 46.9989 41.0383 47.0625 41.2175 47.3284L42.0095 48.4616L45.1892 45.2819C45.4147 45.0564 45.7789 45.0564 46.0044 45.2819C46.2298 45.5073 46.2298 45.8716 46.0044 46.097L42.3391 49.7623C42.2292 49.8722 42.0847 49.93 41.9286 49.93C41.9113 49.93 41.8939 49.93 41.8766 49.93C41.7089 49.9127 41.5528 49.8259 41.4545 49.6872L40.2694 47.9933C40.0902 47.7273 40.1538 47.3689 40.4139 47.1839Z",
    fill: "url(#paint1_linear_6779_1492)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6779_1492",
    x1: 33.5,
    y1: 19.5957,
    x2: 33.5,
    y2: 45.8368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6779_1492",
    x1: 43.1773,
    y1: 42.1484,
    x2: 43.1773,
    y2: 53.4045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestAcceptActivityIcon);
export default __webpack_public_path__ + "static/media/InterestAccept-Activity-icon.46033fc33c0d8a0d4e50da453340d780.svg";
export { ForwardRef as ReactComponent };